/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IExampleParent {}


